










































































































































// decoradores
import { Vue, Component } from "vue-property-decorator";
// vuex
import { mapActions, mapGetters } from "vuex";
// tipos

// componentes
import TablaProveedor from "@/components/proveedores/Tabla.vue";
import FormularioProveedor from "@/components/proveedores/Formulario.vue";
import { DataFormularioProveedor } from "@/typings/components/proveedores/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import DialogoEliminar from "@/components/DialogoEliminar.vue";
import InfoProveedor from "@/components/proveedores/Info.vue";
//import BotonesCrud from "@/components/BotonesCrud.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
//import TituloVista from "@/components/TituloVista.vue";
import {
  Proveedor,
  Proveedores,
  //  Regiones,
} from "@/typings/store/plugins/easyFirestore/proveedores";
//import { DataFormularioRegion } from "@/typings/components/regiones/formulario";
import CargarProveedoresExcel from "@/components/excel/CargarProveedores.vue";
import ExportarExcelGenerico from "@/components/ExportarExcelGenerico.vue";
import ExportarPdfGenerico from "@/components/ExportarPdfGenerico.vue";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["proveedores"]) {
    return true;
  }

  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to) {
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to);
      }
      return false;
    }
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getProveedores: "proveedores/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",

    getRutasUsuario: "usuario/getRutas",
    getArrayProveedores: "proveedores/getArray",
  }),
  methods: mapActions({
    setProveedor: "proveedores/set",
    deleteProveedor: "proveedores/delete",
    insertBatchProveedores: "proveedores/insertBatch",
    //setArchivo: "archivos/set",
    //deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoEliminar,
    DialogoExito,
    TablaProveedor,
    FormularioProveedor,
    InfoProveedor,
    //BotonesCrud,
    MensajeEliminar,
    CargarProveedoresExcel,
    ExportarExcelGenerico,
    ExportarPdfGenerico,
    //TituloVista,
  },
})
export default class VistaBancos extends Vue {
  created(): void {
    if (!routeGuard(this)) {
      return;
    }
  }

  cargando = false;
  dialogoExito = {
    model: false,
    texto: "",
    icono: "",
  };
  search = "";
  proveedor: Proveedor | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  textoEliminar = "¿ESTÁS SEGURO QUE DESEAS ELIMINAR ESTE PROVEEDOR?";
  dialogoCargarExcel = false;

  get columnasExportacionProveedores(): Array<{ label: string; field: string }> {
    return [
      { label: "Codigo", field: "CodAux" },
      { label: "Nombre", field: "NomAux" },
      { label: "Rut", field: "RutAux" },
      { label: "Nombre Aux", field: "NomAux2" },
    ];
  }

  get proveedores(): Proveedores {
    return this.getProveedores;
  }

  get items(): Array<Proveedor> {
    return this.getArrayProveedores;
  }

  clickItem(val: { id: string } | null): void {
    this.proveedor = val ? this.proveedores[val.id] : null;
  }

  clickPlus(): void {
    this.proveedor = null;
    this.dialogoFormulario = true;
  }

  async clickGuardar(data: DataFormularioProveedor): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    await this.setProveedor(doc);
    if (doc.id != this.proveedor?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Proveedor creado con éxito!",
        icono: require("../assets/icons/double-check-duo.svg"),
      };
    }
    if (doc.id == this.proveedor?.id) {
      this.dialogoExito = {
        model: true,
        texto: "¡Proveedor editado con éxito!",
        icono: require("../assets/icons/editar.svg"),
      };
      this.proveedor = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = {
      model: false,
      texto: "",
      icono: "",
    };
  }

  clickEliminar(): void {
    const proveedor = this.proveedor;
    if (!proveedor?.id) {
      console.error("error id: ", proveedor);
      return;
    }
    this.deleteProveedor(proveedor.id);
    this.proveedor = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(proveedor: Proveedor): void {
    if (!proveedor.id) {
      console.error("error id: ", proveedor);
      return;
    }
    const doc = this.proveedores[proveedor.id];
    if (doc) {
      this.proveedor = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.proveedor = null;
  }

  abrirDialogoFormulario(proveedor: Proveedor): void {
    if (!proveedor.id) {
      console.error("error id: ", proveedor);
      return;
    }
    const doc = this.proveedores[proveedor.id];
    if (doc) {
      this.proveedor = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(proveedor: Proveedor): void {
    if (!proveedor.id) {
      console.error("error id: ", proveedor);
      return;
    }
    const doc = this.proveedores[proveedor.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.proveedor = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.proveedor = null;
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.proveedor = null;
  }
}
